import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringIndexOfExpression extends ExpressionRule {
    readonly __type: string = "String Index Of";
    readonly __ruleName: string = "Index Of";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();

        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new StringDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).indexOf(this.value2.evaluate(data, testContext));
    }
}
